module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/7jovTJ/tc-custom/9781634867917.jpg?1723404185526",
      "alt": "This image is the cover for the book Snowed In: Dylan and Kimo, Snowed In"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Snowed In: Dylan and Kimo, Snowed In\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Dylan is facing the anniversary of the death of his first lover, but while he’s on vacation through Oregon, a massive snowstorm hits the coast and he finds himself stranded."), _c('br'), _c('br'), _vm._v("Hawaiian native Kimo drives up and down the Pacific coast repairing office equipment. When the snowstorm hits, he spins out and gets stuck. Fortunately for him Dylan stops and pulls him out. But the road ahead is closed due to the storm, so they return to the nearest town only to discover there’s one room left at the only hotel and they’re forced to share it."), _c('br'), _c('br'), _vm._v("The two develop a bond and friendship as the electricity goes out and they watch the storm in the middle of the night. One thing leads to another and they end up in bed together. When the storm clears, though, things are up in the air. With Dylan living hundreds of miles away in San Jose and Kimo always on the road, will they be able to create a deeper relationship?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      David O. Sullivan\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0